import { DateTimePicker } from "@/shared/ui/DateTimePicker";
import { Field } from "@/shared/forms/Field";
import type * as React from "react";
import { Controller, useFormContext } from "react-hook-form";

type CaptionLayout =
  | "label"
  | "dropdown"
  | "dropdown-months"
  | "dropdown-years"
  | undefined;

type FormDateTimePickerProps = {
  name: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  requiredMark?: boolean;
  datePlaceholder?: string;
  timePlaceholder?: string;
  disabled?: boolean;
  className?: string;
  clearable?: boolean;
  captionLayout?: CaptionLayout;
  fromYear?: number;
  toYear?: number;
};

export function FormDateTimePicker({
  name,
  label,
  hint,
  requiredMark,
  datePlaceholder,
  timePlaceholder,
  disabled,
  className,
  clearable,
  captionLayout,
  fromYear,
  toYear,
}: FormDateTimePickerProps) {
  const { control } = useFormContext();

  return (
    <Field name={name} label={label} hint={hint} requiredMark={requiredMark}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <DateTimePicker
            value={(field.value as string | null | undefined) ?? null}
            onChange={field.onChange}
            datePlaceholder={datePlaceholder}
            timePlaceholder={timePlaceholder}
            disabled={disabled}
            className={className}
            clearable={clearable}
            captionLayout={captionLayout}
            fromYear={fromYear}
            toYear={toYear}
          />
        )}
      />
    </Field>
  );
}
